import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";
import { routes } from "../../constants/consts-routes";
import Svg from "../Svg/Svg";
import {
  getLanguageCode,
  setLockedViewport
} from "../../services/service-utils";
import MenuToggle from "../MenuToggle/MenuToggle";
import Menu from "../Menu/Menu";
import DropdownTiny from "../DropdownTiny/DropdownTiny";
// import { analyticsEvent } from "../../services/service-gtm";
import { resetPageIndex } from "../../services/service-url-search-params";
import { defaultQuery } from "../../constants/const-param-keys";
import Navigation from "../Navigation/Navigation";
import { AutoSizer } from "react-virtualized";

class Header extends Component {
  constructor(props) {
    super(props);

    this.onMenuToggle = this.onMenuToggle.bind(this);
    this.onLangClick = this.onLangClick.bind(this);

    this.state = {
      menuOpen: false,
      lang: getLanguageCode(),
      myListParams: ""
    };
  }

  onMenuToggle() {
    this.setState(prevState => {
      return {
        menuOpen: !prevState.menuOpen
      };
    });
  }

  onMenuItemClick = () => {
    this.setState({ menuOpen: false });
  };

  onLangClick(event, lang) {
    // analyticsEvent("Language", "Select", lang);

    const pathname = window.location.pathname + window.location.search;
    const path = pathname;
    const langPath = path.slice(0, 4);

    if (langPath === "/en/") {
      window.location.href = pathname.slice(3);
    } else {
      window.location.href = "/en" + pathname;
    }
  }

  get altStyling () {
    const {location} = this.props;
    return location.pathname.startsWith('/artwork/image');
  }

  renderLogo() {
    const { location } = this.props;

    const search = resetPageIndex(location.search);

    return (
      <div className={`${styles.bar} ${styles.barLogo}`}>
        <Link
          to={routes.search.pathname + (search ? search : defaultQuery)}
          aria-label={routes.search.title}
          onClick={() => setLockedViewport(false)}
        >
          <Svg id="logo" />
        </Link>
      </div>
    );
  }

  renderLanguage() {
    const { lang } = this.state;

    const langOther = lang === "da" ? "en" : "da";

    return (
      <DropdownTiny label={lang.toUpperCase()} ariaLabel={lang} altStyling={this.altStyling}>
        <button onClick={event => this.onLangClick(event, langOther)}>
          {langOther.toUpperCase()}
        </button>
      </DropdownTiny>
    );
  }

  renderDropdown() {
    const { menuOpen } = this.state;

    return <MenuToggle menuOpen={menuOpen} onMenuToggle={this.onMenuToggle} />;
  }

  renderMobile() {
    const { menuOpen } = this.state;

    return (
      <>
        <div className={styles.right}>
          {this.renderLanguage()}
          {this.renderDropdown()}
        </div>
        <Menu menuOpen={menuOpen} onItemClick={this.onMenuItemClick} />
      </>
    );
  }

  renderDesktop() {
    return (
      <div className={styles.right}>
        {<Navigation className={[
          styles.navigation,
          this.altStyling ? styles.navigationAlt : undefined
        ].filter(Boolean).join(' ')} />}
        {this.renderLanguage()}
      </div>
    );
  }

  render() {
    return (
      <header id="header" className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.inner}>
            {this.renderLogo()}
            <AutoSizer disableHeight className={styles.menu}>
              {({ width }) =>
                width > 600 ? this.renderDesktop() : this.renderMobile()
              }
            </AutoSizer>
          </div>
        </div>
      </header>
    );
  }
}

export default withRouter(Header);
